import { render, staticRenderFns } from "./PDFZoom.vue?vue&type=template&id=3c020d00"
import script from "./PDFZoom.vue?vue&type=script&lang=js"
export * from "./PDFZoom.vue?vue&type=script&lang=js"
import style0 from "./PDFZoom.vue?vue&type=style&index=0&id=3c020d00&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports